import { MonthlyChartProps } from './index';
import { fmtHrs } from '@/lib/time';

export type UseHooksParams = MonthlyChartProps;

interface MonthGroup {
  monthKey: string;
  label: string;
  hours: number;
  displayHours: string;
  percentage: number;
}

export const useHooks = ({ dayMap }: UseHooksParams) => {
  const monthlyTotals: Record<string, number> = {};
  
  for (const [dateStr, hrs] of Object.entries(dayMap)) {
    const month = dateStr.substring(0, 7);
    monthlyTotals[month] = (monthlyTotals[month] || 0) + hrs;
  }
  
  const sortedMonths = Object.entries(monthlyTotals)
    .sort((a, b) => b[0].localeCompare(a[0]));
    
  const maxHours = sortedMonths.reduce((max, [, hrs]) => Math.max(max, hrs), 0);
  
  const chartItems: MonthGroup[] = sortedMonths.map(([month, hrs]) => {
    const percentage = maxHours > 0 ? (hrs / maxHours) * 100 : 0;
    
    return {
      monthKey: month,
      label: month,
      hours: hrs,
      displayHours: fmtHrs(hrs),
      percentage
    };
  });
  
  return {
    chartItems
  };
};
